/* ============================================================
   GORNATION Help Center
   ------------------------------------------------------------
   Suche, Themenfilter und der Rueckfall fuer den GORBOT Embed.

   Suchfeld und FAQ liegen in ZWEI verschiedenen Sections. Deshalb
   arbeitet das Skript global auf dem Dokument und sammelt seine
   Elemente bei jedem refresh() neu ein. Im Theme-Editor rendert
   Shopify einzelne Sections nach, ohne die Seite neu zu laden;
   ohne das Nachsammeln waeren die Verweise danach tot.
   ============================================================ */

(function () {
  'use strict';

  // Jede Section bindet dieses Skript ein, damit sie auch einzeln
  // funktioniert. Ohne diese Sperre liefen die delegierten Klick-Handler
  // mehrfach, und ein Themenfilter haette sich sofort selbst wieder
  // aufgehoben.
  if (window.__gnHelpCenterLoaded) return;
  window.__gnHelpCenterLoaded = true;

  /* ------------------------------------------------------------
     Sprachwahl: die Seite folgt der Shopsprache.

     Die Seite existiert als VIER Vorlagen: Deutsch als Standard,
     Englisch, Franzoesisch und Italienisch je ueber ?view=. Auf
     einem Shop MIT Sprachversionen ist der Rest des Shops laengst
     in der Sprache des Besuchers, nur diese Seite bliebe stur bei
     der Vorlage, die gerade in der URL steht. Deshalb leitet das
     Skript um.

     DIE SHOPSPRACHE ENTSCHEIDET, IMMER. Bis zum 20.08. galt
     ?view=helpcenter-en als ausdrueckliche Wahl und schlug die
     Automatik. Das war falsch, und zwar sichtbar falsch: schaltet
     ein Besucher oben im Kopf die Sprache um, schickt Shopify ihn
     auf DIESELBE URL zurueck, der view-Parameter steht also noch
     drin. Er waehlte Deutsch und blieb auf der englischen Seite.
     Der view-Parameter ist kein Wunsch, er ist
     der Transportweg zu einer Vorlage.

     Zwei Grenzen bleiben:

     1. NUR auf Shops mit Sprachversionen. Erkennbar an den
        hreflang-Links, die Shopify nur dann in den Kopf schreibt.
        Der Dev-Store hat keine, dort greift die Weiche nie und
        ?view= bleibt der Weg fuer Abnahme und Vorschau.
     2. ?gn_sprachweiche=aus schaltet sie ab. Das ist der Weg, eine
        Sprachfassung auf einem Shop MIT Sprachversionen anzusehen,
        ohne die Storefront umzuschalten. Bewusst ein eigener
        Parameter und nicht wieder der view-Parameter: dieser hier
        steht nur in der URL, wenn ihn jemand hingeschrieben hat.

     Sprachen ohne eigene Fassung bekommen Englisch, das ist auch
     das x-default des Shops.

     Kein Endlos-Kreisel moeglich: das Ziel ist immer die Vorlage,
     deren Sprache zur Shopsprache passt, und dort stoppt der
     Vergleich unten.
     ------------------------------------------------------------ */

  // Zuordnung Sprache -> Vorlage. Dieselbe Tabelle steht in
  // theme/snippets/gn-help-ansicht.liquid, die zwei koennen einander nicht
  // lesen (Liquid rendert auf dem Server, das hier laeuft im Browser).
  // Aendert sich eine, gehoert die andere mit.
  var ANSICHT = {
    de: 'helpcenter',
    en: 'helpcenter-en',
    fr: 'helpcenter-fr',
    it: 'helpcenter-it'
  };

  function folgeShopsprache() {
    try {
      var loc = window.location;
      if (!loc || typeof loc.replace !== 'function') return false;
      if (typeof URLSearchParams !== 'function') return false;

      var params = new URLSearchParams(loc.search || '');
      if (params.get('gn_sprachweiche') === 'aus') return false;
      if (!document.querySelector('link[hreflang]')) return false;

      var traeger = document.querySelector('[data-gn-page-lang]');
      if (!traeger) return false;
      var seite = (traeger.getAttribute('data-gn-page-lang') || 'de').slice(0, 2).toLowerCase();
      var shop = ((document.documentElement && document.documentElement.getAttribute('lang')) || 'en')
        .slice(0, 2).toLowerCase();
      var ziel = ANSICHT[shop] ? shop : 'en';
      if (ziel === seite) return false;

      // Vorhandene Parameter (z. B. preview_theme_id) bleiben erhalten.
      params.set('view', ANSICHT[ziel]);
      loc.replace(loc.pathname + '?' + params.toString() + (loc.hash || ''));
      return true;
    } catch (e) {
      // Im Zweifel keine Umleitung: eine deutsche Seite fuer einen englischen
      // Besucher ist aergerlich, eine kaputte Seite waere schlimmer.
      return false;
    }
  }

  var GNHelpCenter = {
    input: null,
    items: [],
    groups: [],
    topics: [],
    noHits: null,
    activeCat: null,
    feedbackBox: null,

    /* ------------------------------------------------------------
       Suchfeld-Analytik: Was suchen Kunden, finden sie
       etwas, und hilft ihnen die Seite? Events gehen an /chat-event
       der GORBOT-App — dieselbe Leitung, die das Widget fuer
       Feedback und Themen-Klicks nutzt.

       Grundsaetze:
       - Analytik darf die Seite NIE brechen: jeder Pfad schluckt
         Fehler still, ohne App-URL passiert einfach nichts.
       - Keine Kundendaten im Klartext: E-Mail-Adressen und laengere
         Ziffernfolgen (Bestellnummern, Telefonnummern) werden VOR dem
         Senden ersetzt. Kunden tippen so etwas erfahrungsgemaess auch
         in Suchfelder.
       ------------------------------------------------------------ */

    /** App-URL aus der Konfiguration des Chat-Widgets, sonst nichts. */
    eventEndpoint: function () {
      try {
        // App Proxy hat Vorrang: dann laeuft das Event ueber die Shop-Domain und
        // Shopify signiert es, genau wie die Aufrufe des Widgets.
        //
        // WARUM DAS HIER STEHEN MUSS: diese Seite hat ihren EIGENEN Sender, das
        // Widget kennt ihn nicht. Am 14.08. lief /chat deshalb schon ueber den
        // Proxy, waehrend die Suchanalytik weiter direkt gegen Fly ging (im
        // Network-Tab sichtbar). Sobald der Server nur noch signierte Anfragen
        // annimmt (REQUIRE_PROXY_SIGNATURE), waeren genau diese Events still mit
        // 403 gestorben — und "still" ist hier woertlich: sendBeacon liefert
        // kein Ergebnis zurueck, und Analytik darf die Seite nie stoeren. Der
        // Ausfall waere erst aufgefallen, wenn im Dashboard Wochen spaeter
        // Zahlen fehlen.
        var proxy = (window.shopChatConfig && window.shopChatConfig.proxyPath) || '';
        proxy = String(proxy).trim().replace(/\/+$/, '');
        if (/^\/[A-Za-z0-9_\-/]*$/.test(proxy) && proxy) return proxy + '/chat-event';

        var raw = (window.shopChatConfig && window.shopChatConfig.appUrl) || '';
        if (!/^https:\/\//.test(raw)) return null;
        return raw.replace(/\/+$/, '') + '/chat-event';
      } catch (e) { return null; }
    },

    /** Eine Kennung pro Browser-Sitzung, damit sich Events gruppieren lassen. */
    sessionId: function () {
      try {
        var sid = sessionStorage.getItem('gn-hc-sid');
        if (!sid) {
          sid = 'hc-' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
          sessionStorage.setItem('gn-hc-sid', sid);
        }
        return sid;
      } catch (e) { return 'hc-anon'; }
    },

    /** Kundendaten raus, Laenge deckeln. */
    scrubValue: function (value) {
      return String(value || '')
        .replace(/\S+@\S+/g, '[email]')
        .replace(/\d[\d\s-]{5,}\d/g, '[nr]')
        .trim()
        .slice(0, 100);
    },

    sendEvent: function (type, value) {
      try {
        var url = this.eventEndpoint();
        if (!url) return;
        var body = JSON.stringify({
          conversation_id: this.sessionId(),
          type: type,
          value: this.scrubValue(value),
        });
        // sendBeacon uebersteht auch das Verlassen der Seite; der
        // fetch-Rueckfall ist fire-and-forget.
        if (navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
        } else {
          fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
        }
      } catch (e) { /* Analytik bricht nie die Seite */ }
    },

    // Suche erst melden, wenn der Kunde zu Ende getippt hat — sonst
    // erzeugt "versandkosten" zwoelf Events statt einem.
    searchTimer: null,
    lastReported: '',

    reportSearch: function () {
      var self = this;
      if (this.searchTimer) window.clearTimeout(this.searchTimer);
      this.searchTimer = window.setTimeout(function () {
        var query = self.input ? self.input.value.trim() : '';
        if (query.length < 3 || query === self.lastReported) return;
        self.lastReported = query;
        var hits = self.items.filter(function (i) { return !i.hidden; }).length;
        self.sendEvent('hc_search', hits + '|' + query);
        if (hits === 0) self.sendEvent('hc_nohit', query);
        self.showFeedback();
      }, 1200);
    },

    /**
     * Schreibweisen vereinheitlichen, damit "groesse", "größe" und
     * "grosse" denselben Treffer liefern. Kunden tippen alle drei
     * Varianten. Dafuer landet alles auf dem blanken Vokal (ö -> o
     * UND oe -> o): die alte Form (nur ö -> oe) konnte das getippte
     * "grosse" nie treffen, weil aus "Größe" "groesse" wurde
     * (DOM-Testlauf 11.08.). Bindestriche fliegen ebenfalls raus,
     * sonst findet "email" das geschriebene "E-Mail" nicht. Suchwort
     * und Haystack laufen beide hier durch, das Matching bleibt
     * also konsistent.
     */
    normalize: function (value) {
      return String(value)
        .toLowerCase()
        .replace(/ä/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/ü/g, 'u')
        .replace(/ß/g, 'ss')
        .replace(/ae/g, 'a')
        .replace(/oe/g, 'o')
        .replace(/ue/g, 'u')
        .replace(/[-–—]/g, '');
    },

    /**
     * Feedback-Zeile einblenden, sobald der Kunde die Suche oder den
     * Themenfilter wirklich benutzt hat. Vorher waere die Frage "hast du
     * gefunden, was du gesucht hast?" sinnlos. Wer schon geantwortet hat,
     * wird in dieser Sitzung nicht noch einmal gefragt.
     */
    showFeedback: function () {
      try {
        if (!this.feedbackBox) return;
        if (sessionStorage.getItem('gn-hc-fb-done')) return;
        this.feedbackBox.hidden = false;
      } catch (e) { /* still */ }
    },

    answerFeedback: function (verdict) {
      var query = this.input ? this.input.value.trim() : '';
      this.sendEvent('hc_feedback', verdict + '|' + (query || this.activeCat || ''));
      try { sessionStorage.setItem('gn-hc-fb-done', '1'); } catch (e) { /* still */ }
      if (!this.feedbackBox) return;
      var buttons = this.feedbackBox.querySelector('[data-gn-hc-feedback-buttons]');
      var thanks = this.feedbackBox.querySelector('[data-gn-hc-feedback-thanks]');
      if (buttons) buttons.hidden = true;
      if (thanks) thanks.hidden = false;
    },

    refresh: function () {
      this.input = document.querySelector('input[data-gn-hc-search]');
      this.items = Array.prototype.slice.call(document.querySelectorAll('[data-gn-hc-qa]'));
      this.groups = Array.prototype.slice.call(document.querySelectorAll('[data-gn-hc-group]'));
      this.topics = Array.prototype.slice.call(document.querySelectorAll('[data-gn-hc-topic]'));
      this.noHits = document.querySelector('[data-gn-hc-nohits]');
      this.feedbackBox = document.querySelector('[data-gn-hc-feedback]');

      /*
       * WELCHE FRAGE WIRD AUFGEKLAPPT.
       *
       * Die Auswertung wusste bisher, WONACH gesucht wurde und was NICHT
       * gefunden wurde, aber nicht, welche der Fragen jemand liest. Genau das
       * entscheidet, welche FAQ ihren Platz verdient und welche gehen kann.
       *
       * Gezaehlt wird nur das AUFklappen, einmal je Frage und Sitzung: wer
       * zweimal hin und her klickt, ist EIN Leser, nicht zwei. 'toggle'
       * steigt nicht auf, der Zuhoerer haengt deshalb DIREKT an jedem
       * Eintrag. Er haengt hier in refresh() und NICHT in bind(): bind()
       * laeuft vor dem Einsammeln der Eintraege, und der Theme-Editor
       * rendert Sections neu, deren frische Knoten sonst stumm blieben. Das
       * data-Flag verhindert die Doppelbindung beim erneuten refresh().
       */
      var self = this;
      this.items.forEach(function (qa) {
        if (qa.dataset.gnHcFaqGebunden) return;
        qa.dataset.gnHcFaqGebunden = '1';
        qa.addEventListener('toggle', function () {
          if (!qa.open) return;
          var id = qa.getAttribute('data-gn-hc-id') || '';
          if (!id) return;
          if (!self.geoeffnet) self.geoeffnet = {};
          if (self.geoeffnet[id]) return;
          self.geoeffnet[id] = true;
          // Kennung UND Fragetext: die Kennung ist stabil, der Text macht
          // die Auswertung ohne Nachschlagen lesbar.
          var summary = qa.querySelector('summary');
          var frage = summary ? summary.textContent.trim().replace(/\s+/g, ' ') : '';
          self.sendEvent('hc_faq', id + '|' + frage.slice(0, 80));
        });
      });

      // Ein Thema, das es nach einer Aenderung im Theme-Editor nicht mehr
      // gibt, darf die Liste nicht dauerhaft leer filtern.
      if (this.activeCat && !this.hasCategory(this.activeCat)) {
        this.activeCat = null;
      }

      this.syncTopicState();
      this.apply();
    },

    hasCategory: function (cat) {
      return this.topics.some(function (topic) {
        return topic.getAttribute('data-gn-hc-topic') === cat;
      });
    },

    syncTopicState: function () {
      var active = this.activeCat;
      this.topics.forEach(function (topic) {
        var isOn = topic.getAttribute('data-gn-hc-topic') === active;
        topic.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      });
    },

    // Fuellwoerter, die in fast jeder Frage stecken und nichts unterscheiden.
    // Ohne den Filter fand "wo ist meine bestellung" nichts, weil die Phrase
    // wortwoertlich nirgends steht. Die Liste steht in der
    // Normalform aus normalize(), deshalb "fur" und "uber" statt fuer/ueber.
    stopwords: ' der die das den dem des ein eine einen wo wie was wann wer warum ist sind war kann man mein meine meiner mir mich ich du ihr wir es und oder auch noch nicht bitte mal fur uber bei nach von zu im in an auf the my is are a i what which when where why how who whose does can will would you your yours get got do dont our their there here about with from ',

    /** Bedeutungstragende Suchwoerter, normalisiert. Von apply() UND dem
        Treffer-Ranking in submitSearch() benutzt — eine Quelle, ein Verhalten. */
    tokenize: function (value) {
      var stopwords = this.stopwords;
      return this.normalize(String(value || '').trim()).split(/\s+/).filter(function (w) {
        return w.length >= 3 && stopwords.indexOf(' ' + w + ' ') === -1;
      });
    },

    /** Kommt das Wort (oder sein Stamm, min. 5 Zeichen) im Text vor? */
    tokenInText: function (token, normalizedText) {
      if (normalizedText.indexOf(token) !== -1) return true;
      var stem = token.slice(0, Math.max(5, token.length - 3));
      return stem.length >= 5 && normalizedText.indexOf(stem) !== -1;
    },

    apply: function () {
      var raw = this.input ? this.normalize(this.input.value.trim()) : '';
      var active = this.activeCat;
      var normalize = this.normalize;
      var hits = 0;

      // Wort-Suche statt Phrasen-Substring: jedes bedeutungstragende Wort
      // muss vorkommen (UND). "wo ist meine bestellung" -> ["bestellung"].
      var tokens = this.tokenize(this.input ? this.input.value : '');
      // Nur Fuellwoerter getippt? Dann wie eine leere Suche behandeln.
      var term = tokens.length ? raw : '';

      var self = this;
      this.items.forEach(function (item) {
        var catOk = !active || item.getAttribute('data-gn-hc-cat') === active;
        var haystack = normalize(item.getAttribute('data-gn-hc-search') || '');
        // Wortstamm statt exaktem Wort: "verfolgen" muss "verfolge ich"
        // treffen, "bestellungen" auch "Bestellung" (tokenInText).
        var textOk = !term || tokens.every(function (w) {
          return self.tokenInText(w, haystack);
        });
        var show = catOk && textOk;

        item.hidden = !show;
        if (show) {
          hits++;
        }

        // Ab drei Zeichen die Treffer aufklappen: der Kunde sucht dann
        // eine Antwort, nicht eine Liste von Ueberschriften. Ohne Suchterm
        // wird open NICHT angefasst: sonst klappte jedes Tippen (auch 1-2
        // Zeichen) eine manuell geoeffnete Antwort unter dem Kunden zu
        // sonst zu.
        if (term) {
          item.open = term.length > 2 && show;
        }
      });

      this.groups.forEach(function (group) {
        group.hidden = group.querySelectorAll('[data-gn-hc-qa]:not([hidden])').length === 0;
      });

      if (this.noHits) {
        this.noHits.style.display = hits ? 'none' : 'block';
      }
    },

    jumpToFaq: function () {
      var faq = document.querySelector('[data-gn-hc-faq]');
      if (!faq) return;
      faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    /**
     * Zur gefilterten Liste springen. Nach einem Klick auf eine Themenkachel
     * aendert sich das Ergebnis WEITER UNTEN auf der Seite, auf dem Handy
     * komplett ausserhalb des Bildes. Ohne diesen Sprung sieht der Kunde nach
     * dem Klick nichts passieren und haelt die Kachel fuer kaputt.
     *
     * Ziel ist die erste sichtbare Gruppe, nicht die FAQ-Sektion: dort stehen
     * erst die Kacheln, von denen der Klick gerade kam. Faellt auf die Sektion
     * zurueck, falls die Gruppen fehlen (z. B. Thema ohne Fragen).
     */
    /**
     * Grosser Bildschirm? Entscheidet, ob ein Fokus gesetzt werden darf, ohne
     * dass die Bildschirmtastatur den Inhalt verdeckt. 940px ist dieselbe
     * Grenze, an der die CSS auf zwei Spalten umbricht.
     *
     * Kennt der Browser matchMedia nicht, wird NICHT fokussiert: der Sprung
     * allein funktioniert immer, ein Fokus zur falschen Zeit nicht.
     */
    isWideViewport: function () {
      if (typeof window.matchMedia !== 'function') return false;
      return window.matchMedia('(min-width: 940px)').matches === true;
    },

    scrollToResults: function () {
      var group = this.groups.find(function (g) { return !g.hidden; });
      if (group) {
        group.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      this.jumpToFaq();
    },

    /**
     * Enter oder Lupe in der Suche: nicht stumpf zur FAQ-Sektion springen
     * (dort stehen erst die Themenkacheln), sondern dahin, wo die Antwort
     * ist — zum ERSTEN passenden Eintrag. Und findet die Seite nichts,
     * geht die getippte Frage direkt an GORBOT statt in eine Sackgasse.
     */
    submitSearch: function (opts) {
      var curated = !!(opts && opts.curated);
      var query = this.input ? this.input.value.trim() : '';
      if (!query) { this.jumpToFaq(); return; }

      // Die Suche oben schlaegt einen weiter unten aktiven Themenfilter:
      // sonst filtert beides UND-verknuepft still auf null Treffer und die
      // Frage geht an GORBOT, obwohl die FAQ die Antwort hat.
      this.activeCat = null;
      this.syncTopicState();
      this.apply();

      var self = this;
      var visible = this.items.filter(function (item) { return !item.hidden; });

      // Gar kein Treffer: wie bisher direkt zu GORBOT.
      if (visible.length === 0) {
        this.sendEvent('hc_gorbot', query);
        this.sendToGorbot(query);
        return;
      }

      // Kuratierte Pills ("Versandkosten", "Groesse finden") duerfen immer
      // springen: das Ziel haben wir selbst gewaehlt. Aber zum RICHTIGEN
      // Treffer: "Versandkosten" landete bei der
      // Erstattungs-Frage, weil deren ANTWORT "Hinversandkosten" enthaelt und
      // sie seit dem MVP-Umbau im Dokument VOR der Versand-Frage steht. Ein
      // Treffer in Frage oder kuratierten Suchwoertern schlaegt deshalb den
      // blossen Antwort-Treffer; erst ohne solchen gilt wieder der erste.
      if (curated) {
        var cTokens = this.tokenize(query);
        var self2 = this;
        var cQuestionMatch = visible.find(function (item) {
          var summary = item.querySelector('summary');
          var strong = self2.normalize(
            (summary ? summary.textContent : '') + ' ' + (item.getAttribute('data-gn-hc-keywords') || '')
          );
          return cTokens.length > 0 && cTokens.every(function (w) { return self2.tokenInText(w, strong); });
        });
        (cQuestionMatch || visible[0]).scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      // Getippte Suche: nur ein GUTES Match verdient den Sprung. Beobachtet:
      // "von wo paket" sprang zu "Liefert ihr in mein Land?", weil
      // "Paket" irgendwo in deren ANTWORT stand — am Ziel vorbei).
      // Gut heisst: der Treffer ist eindeutig (genau einer), oder die FRAGE
      // selbst enthaelt alle Suchwoerter. Reine Antwort-Treffer bei mehreren
      // Kandidaten sind Raten — die Frage geht stattdessen an GORBOT, der
      // antwortet statt zu verlinken.
      if (visible.length === 1) {
        visible[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      // Frage-Treffer: alle Suchwoerter kommen in der FRAGE vor — oder in den
      // kuratierten Keywords des Eintrags (data-gn-hc-keywords, gepflegt in
      // der Wissensbasis: Formulierungen, die Kunden tippen, die aber im
      // Text nicht vorkommen). Gesprungen wird NUR bei GENAU EINEM solchen
      // Treffer: "bestellung" trifft vier Fragen, welche gemeint ist, weiss
      // nur der Kunde — also GORBOT statt raten.
      var tokens = this.tokenize(query);
      var questionMatches = tokens.length === 0 ? [] : visible.filter(function (item) {
        var summary = item.querySelector('summary');
        var strong = self.normalize(
          (summary ? summary.textContent : '') + ' ' + (item.getAttribute('data-gn-hc-keywords') || '')
        );
        return tokens.every(function (w) {
          return self.tokenInText(w, strong);
        });
      });

      if (questionMatches.length === 1) {
        questionMatches[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      this.sendEvent('hc_gorbot', query);
      this.sendToGorbot(query);
    },

    /**
     * Nachricht direkt an GORBOT schicken: zum Chat scrollen, Text ins
     * Eingabefeld des Widgets legen und dessen Enter-Handler ausloesen.
     * Der Umweg ueber das Eingabefeld ist Absicht: das Widget kapselt
     * seine Sende-Logik, und der Enter-Pfad raeumt Panels auf und pflegt
     * den Verlauf, genau wie bei einer echten Eingabe.
     *
     * Ist das Widget nicht da (App-Einbettung aus), wird nur gescrollt.
     * Dort steht dann die Rueckfall-Karte mit dem Kontaktweg.
     */
    /**
     * Lokale GORBOT-Nachricht ohne Serverrunde: Ereignis ans Widget, das den
     * Text als Assistent-Blase rendert, dann zum Chat scrollen und das
     * Eingabefeld fokussieren (Desktop; am Handy wuerde die Tastatur die
     * Nachricht verdecken). Liefert false, wenn das Widget fehlt: dann faellt
     * der Aufrufer auf den normalen Sendeweg zurueck.
     */
    zeigeLokaleNachricht: function (text, frage) {
      var host = document.querySelector('[data-gorbot-inline]');
      if (!host || host.getAttribute('data-gorbot-ready') !== 'true') return false;
      try {
        document.dispatchEvent(new (window.CustomEvent || CustomEvent)('gorbot:hinweis', { detail: { text: String(text), frage: String(frage || ''), anmelden: true } }));
      // anmelden: true, weil dieser Weg NUR abgemeldet laeuft (siehe Aufrufstelle)
      // und beide Kacheln Bestellwege sind: der Kasten unter der Blase ist der
      // Knopf zu dem Satz 'am schnellsten geht es, wenn du dich kurz anmeldest'
      // Ohne Knopf waere der Satz eine Sackgasse.
      } catch (e) {
        return false;
      }
      /*
       * ⚠️ EINMAL scrollen, und nicht zu weit: gemeldet war "man wird
       * zweimal runter geschoben und ein stueck zu weit".
       *
       * Zwei Fehler in zwei Zeilen. Erstens war das Ziel der GANZE Abschnitt
       * (.gn-hc__section) und `block: 'center'` zentriert ihn — bei einem
       * Abschnitt, der hoeher ist als das Fenster, schiebt das weit ueber den
       * Chat hinaus. Zweitens scrollt das Widget gleich danach in seinem
       * eigenen Behaelter (scrollToBottom in lokaleHinweise), das ist die
       * zweite Bewegung.
       *
       * Jetzt: Ziel ist der CHAT selbst, nicht der Abschnitt, und gescrollt
       * wird nur, wenn er nicht schon brauchbar im Bild steht. Steht er da,
       * bleibt die Seite ruhig und es gibt genau eine Bewegung — die im Chat.
       */
      var ziel = host;
      var r = ziel.getBoundingClientRect();
      var fenster = window.innerHeight || 800;
      // "Brauchbar im Bild": die Oberkante ist sichtbar und der Chat nimmt
      // mindestens die Haelfte des Fensters ein. Dann ist Scrollen nur Unruhe.
      var schonImBild = r.top >= 0 && r.top < fenster * 0.5;
      if (!schonImBild && ziel.scrollIntoView) {
        ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (this.isWideViewport()) {
        var input = document.querySelector('.shop-ai-chat-container .shop-ai-chat-input textarea');
        /*
         * ⚠️ preventScroll ist hier die halbe Miete. focus() nach 450 ms fiel
         * mitten in die weiche Scroll-Bewegung (die dauert in Chrome ~500 ms,
         * egal wie weit): der Browser brach sie ab und scrollte nur so weit,
         * bis das Eingabefeld eben sichtbar war. Gemessen am 20.08. bei 1280:
         * der Chat blieb auf 365 px haengen statt unter der Kopfleiste zu
         * stehen, und unten fehlten 59 px — genau das Eingabefeld mit der
         * KI-Kennzeichnung. Das Scroll-Ziel bestimmt allein scrollIntoView
         * (mit dem scroll-margin-top des Hosts), der Fokus haelt still.
         */
        if (input) window.setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
      }
      return true;
    },

    sendToGorbot: function (message) {
      // Am Handy zuerst die Tastatur schliessen: sonst rechnet der Scroll mit
      // dem vollen Viewport und der Chat landet optisch HINTER der Tastatur,
      // waehrend die Frage schon abgeschickt wird.
      if (!this.isWideViewport() && this.input && typeof this.input.blur === 'function') {
        this.input.blur();
      }
      var host = document.querySelector('[data-gorbot-inline]');
      // textarea ODER input: das Eingabefeld des Widgets ist seit 18.08.
      // mehrzeilig. Beide Formen suchen, damit diese Seite auch mit einem
      // aelteren oder neueren Widget-Stand zusammenspielt.
      var input = document.querySelector('.shop-ai-chat-container .shop-ai-chat-input textarea, .shop-ai-chat-container .shop-ai-chat-input input');

      var target = host || (input && input.closest('.shop-ai-chat-container'));
      /*
       * ⚠️ scrollIntoView LEGT DIE OBERKANTE AN DEN VIEWPORT-RAND — und die
       * klebende Shop-Leiste liegt darueber (Ians Fund 31.08.: "wenn ich im
       * chat bin, dann ist oben wieder abgehackt"). block:'start' allein
       * reicht deshalb nicht, der Chatkopf verschwindet hinter der Leiste.
       *
       * Gemessen statt geraten: das Leisten-Element wird gesucht (klebt oben,
       * ist breit, ist niedrig) und seine Hoehe als Abstand gesetzt.
       * scroll-margin-top ist genau dafuer da und wird von scrollIntoView
       * respektiert — kein eigenes window.scrollTo noetig, das mit dem
       * weichen Scroll konkurrieren wuerde.
       */
      if (target) {
        try {
          var fensterhoehe = window.innerHeight || 800;
          var fensterbreite = window.innerWidth || 320;
          var leiste = 0;
          var kandidaten = document.querySelectorAll('header, .header, [class*="header"]');
          for (var i = 0; i < kandidaten.length; i++) {
            var el = kandidaten[i];
            var st = window.getComputedStyle(el);
            if (st.position !== 'fixed' && st.position !== 'sticky') continue;
            if (st.visibility === 'hidden' || st.display === 'none') continue;
            var r = el.getBoundingClientRect();
            if (r.height <= 0 || r.height > fensterhoehe / 3) continue;  // Overlay, keine Leiste
            if (r.width < fensterbreite * 0.5) continue;                 // Knopf, keine Leiste
            /*
             * ⚠️ UNTERKANTE, NICHT HOEHE (im Browser gemessen, 31.08.).
             *
             * Auf der Dev-Seite kleben ZWEI Leisten uebereinander
             * (Ankuendigung plus Kopfzeile), zusammen bis 171 px. Die Hoehe
             * des groessten Elements allein gibt nur einen Teil davon her —
             * der Rest legte sich weiter ueber den Chatkopf, und genau das
             * war Ians "oben wieder abgehackt". Was zaehlt, ist wie weit der
             * STAPEL nach unten reicht.
             */
            var unten = r.top + r.height;
            if (unten > leiste) leiste = unten;
          }
          target.style.scrollMarginTop = (leiste + 12) + 'px';
        } catch (e) { /* Abstand ist Komfort, nie ein Grund zu brechen */ }
      }
      if (target && target.scrollIntoView) {
        // ⚠️ 'start', NICHT 'center' (Ians Fund 31.08.: "fliegt man hier so
        // weit runter, dass oben gorbot nicht mal mehr steht"). 'center'
        // zentriert den GANZEN Chat-Kasten im Bildschirm — ist er hoeher als
        // der Viewport, schiebt das seinen Anfang nach oben hinaus, und der
        // Kunde sieht die Antwort ohne den Anfang des Gespraechs. 'start'
        // legt die Oberkante an den oberen Rand: der Chat beginnt sichtbar.
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      if (!input || !message) return;

      // Kleine Pause, damit der Scroll sichtbar startet, bevor die
      // Antwort den Verlauf bewegt.
      window.setTimeout(function () {
        input.value = message;
        // Das Feld ueber ein input-Ereignis informieren: es waechst mit dem
        // Inhalt, und ohne diese Meldung bliebe es einzeilig stehen. Bewusst
        // abgesichert: das Mitwachsen ist Kosmetik und darf das Absenden
        // darunter niemals verhindern.
        try {
          input.dispatchEvent(new Event('input', { bubbles: true }));
        } catch (e) { /* aeltere Umgebungen ohne Event-Konstruktor */ }

        // Absenden ueber den SENDE-KNOPF, nicht ueber eine gefaelschte Taste.
        // Die Tastenvariante hing daran, auf welches Ereignis das Widget gerade
        // hoert: mit dem mehrzeiligen Eingabefeld wanderte der Handler von
        // keypress auf keydown, und die Frage landete im Feld, ohne gesendet zu
        // werden. Der Knopf ist der Weg, den auch ein Mensch nimmt.
        var send = document.querySelector('.shop-ai-chat-container .shop-ai-chat-send');
        if (send && typeof send.click === 'function') {
          send.click();
          return;
        }
        // Rueckfall fuer aeltere Widget-Staende ohne Knopf im Markup: beide
        // Tastenereignisse feuern, eines davon trifft.
        input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }));
        input.dispatchEvent(new KeyboardEvent('keypress', { key: 'Enter', bubbles: true }));
      }, 350);
    },

    /**
     * Der Rueckfall im Chat-Kasten. Das GORBOT Widget setzt beim Start
     * data-gorbot-ready auf dem Aufhaenger. Bleibt das aus, ist die
     * App-Einbettung im Theme aus oder die App nicht installiert. Dann
     * soll der Kunde nicht vor einem leeren Kasten sitzen.
     *
     * Bewusst mit Verzoegerung: sofort eingeblendet wuerde der Rueckfall
     * bei jedem normalen Seitenaufruf kurz aufblitzen.
     */
    watchChat: function () {
      var host = document.querySelector('[data-gorbot-inline]');
      if (!host) return;

      var fallback = host.querySelector('[data-gn-hc-chat-fallback]');
      if (!fallback) return;

      window.setTimeout(function () {
        if (host.getAttribute('data-gorbot-ready') !== 'true') {
          fallback.hidden = false;
        }
      }, 3000);
    },

    /**
     * Nach dem Absenden des Kontaktformulars steht auf der Seite nur noch die
     * Bestaetigung — und zwar GANZ UNTEN. Shopify haengt an die Action zwar
     * einen Anker, aber darauf ist kein Verlass: greift er nicht, bleibt der
     * Kunde oben stehen, sieht das verschwundene Formular und haelt seine
     * Nachricht fuer verloren.
     *
     * Deshalb hier selbst hinscrollen und die Bestaetigung fokussieren. Der
     * Fokus ist auch die Ansage fuer Screenreader: ein role="status", das schon
     * beim Laden im DOM steht, wird nicht vorgelesen.
     */
    showFormSuccess: function () {
      var ok = document.querySelector('[data-gn-hc-form-ok]');
      if (!ok) return;

      if (ok.scrollIntoView) {
        ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (typeof ok.focus === 'function') {
        ok.focus({ preventScroll: true });
      }
    },

    /**
     * Rueckfall fuer das Gorgias-Kontaktformular. Der Loader kommt von
     * contact.gorgias.help — blockt ein Adblocker das Script, bliebe nur
     * eine leere Flaeche (der noscript-Zweig greift nicht, JS laeuft ja).
     * Wie watchChat: kurz warten, dann pruefen, ob das iframe da ist.
     */
    watchGorgiasForm: function () {
      var card = document.querySelector('.gn-hc__form-card--gorgias');
      if (!card) return;
      var fallback = card.querySelector('[data-gn-hc-form-fallback]');
      if (!fallback) return;
      window.setTimeout(function () {
        if (!card.querySelector('iframe')) fallback.hidden = false;
      }, 4000);
    },

    /**
     * Nach dem Absenden des Gorgias-Formulars nicht an den Seitenanfang fliegen.
     *
     * URSACHE: Gorgias ersetzt im iframe das hohe Formular
     * durch eine kurze Bestaetigung. Das iframe schrumpft dabei um mehrere
     * hundert Pixel, die Seite wird entsprechend kuerzer — und wenn die neue
     * Gesamthoehe unter die aktuelle Scrollposition faellt, klemmt der Browser
     * die Position nach oben. Der Kunde stand also ploetzlich am Seitenanfang
     * und hat seine Bestaetigung nie gesehen.
     *
     * Shopifys eigenes Formular hat das Problem nicht, dafuer gibt es
     * showFormSuccess(); das hier ist der Gegenpart fuer den iframe-Weg, und der
     * ist der LIVE genutzte.
     *
     * Wir koennen nicht in das fremde iframe hineinsehen (Cross-Origin) und
     * kennen deshalb kein Absende-Ereignis. Beobachtbar ist aber die Hoehe: ein
     * deutliches SCHRUMPFEN passiert praktisch nur beim Absenden. Genau darauf
     * reagieren wir und holen die Karte zurueck ins Bild.
     */
    keepGorgiasFormInView: function () {
      var card = document.querySelector('.gn-hc__form-card--gorgias');
      if (!card || typeof window.ResizeObserver !== 'function') return;

      var letzteHoehe = card.getBoundingClientRect().height;

      var beobachter = new window.ResizeObserver(function () {
        var neueHoehe = card.getBoundingClientRect().height;
        var geschrumpft = letzteHoehe - neueHoehe;
        letzteHoehe = neueHoehe;

        // 120 px Schwelle: Nachwachsen beim Laden, ein aufgeklapptes Auswahlfeld
        // oder eine Fehlermeldung bewegen sich in kleineren Schritten. Nur der
        // Wechsel von Formular auf Bestaetigung ist so ein Sprung.
        if (geschrumpft < 120) return;

        // Nur eingreifen, wenn der Kunde ueberhaupt in der Naehe des Formulars
        // ist. Hat er schon woanders weitergelesen, wuerde ein Scroll ihn
        // stoeren statt ihm zu helfen.
        var kasten = card.getBoundingClientRect();
        var sichtbar = kasten.bottom > 0 && kasten.top < window.innerHeight;
        if (!sichtbar) return;

        if (card.scrollIntoView) {
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      beobachter.observe(card);
    },

    bind: function () {
      var self = this;

      // Delegiert, damit nachgerenderte Sections ohne erneutes Binden laufen.
      document.addEventListener('input', function (event) {
        if (event.target.matches('input[data-gn-hc-search]')) {
          self.apply();
          self.reportSearch();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.matches('input[data-gn-hc-search]')) {
          event.preventDefault();
          self.submitSearch();
        }
      });

      document.addEventListener('click', function (event) {
        // Direktnachricht an GORBOT (Kacheln, Pills, Karten mit Nachricht)
        var gorbot = event.target.closest('[data-gn-hc-gorbot]');
        if (gorbot) {
          event.preventDefault();
          /*
           * SOFORTNACHRICHT statt Serverrunde: ist der Kunde ABGEMELDET und
           * die Kachel traegt einen
           * lokalen Text, zeigt das Widget diesen Text sofort als
           * GORBOT-Nachricht an. Die erste Rueckfrage ("Bestellnummer und
           * E-Mail?") steht ohnehin fest; sie beim Modell abzuholen kostet
           * den Kunden eine Wartezeit und uns dauerhaft eine Antwortrunde.
           * Angemeldete Kunden senden weiter normal, dort ist die Antwort
           * individuell (Knopf "Bestellstatus" oben im Chat).
           */
          var lokal = gorbot.getAttribute('data-gn-hc-lokal') || '';
          var angemeldet = false;
          try {
            angemeldet = !!(window.shopChatConfig && window.shopChatConfig.ctx
              && window.shopChatConfig.ctx.customer && window.shopChatConfig.ctx.customer.loggedIn);
          } catch (e) { /* dann gilt der normale Weg */ }
          /*
           * NUR BEI LEEREM CHAT: die vorgefertigte Aufforderung passt nur, solange
           * es noch keinen Verlauf gibt. Hat der Kunde schon geschrieben,
           * kennt NUR der Server den Zustand (Bestellung schon verifiziert?
           * mitten in einem Thema?), also geht die Frage dann den normalen
           * Weg und GORBOT entscheidet aus dem Verlauf. Leer heisst: noch
           * keine einzige Kunden-Blase, die Begruessung zaehlt nicht.
           */
          var chatLeer = false;
          try {
            chatLeer = !document.querySelector('.shop-ai-chat-messages .shop-ai-message.user');
          } catch (e) { /* dann der normale Weg */ }
          if (lokal && !angemeldet && chatLeer && self.zeigeLokaleNachricht(lokal, gorbot.getAttribute('data-gn-hc-gorbot') || '')) {
            return;
          }
          self.sendToGorbot(gorbot.getAttribute('data-gn-hc-gorbot') || '');
          return;
        }

        // Kein Suchtreffer: die getippte Frage wandert 1:1 zu GORBOT
        var ask = event.target.closest('[data-gn-hc-ask]');
        if (ask) {
          event.preventDefault();
          var term = self.input ? self.input.value.trim() : '';
          // DIE Kennzahl: diese Frage hat die Seite nicht beantwortet.
          self.sendEvent('hc_gorbot', term);
          self.sendToGorbot(term);
          return;
        }

        // Pill mit Suchbegriff: Begriff in die Suche legen und zum ersten
        // Treffer springen — Klick auf "Versandkosten" landet BEI den
        // Versandkosten, nicht bei den Themenkacheln.
        var queryPill = event.target.closest('[data-gn-hc-query]');
        if (queryPill) {
          event.preventDefault();
          if (self.input) self.input.value = queryPill.getAttribute('data-gn-hc-query');
          self.activeCat = null;
          self.syncTopicState();
          self.submitSearch({ curated: true });
          return;
        }

        var searchBtn = event.target.closest('[data-gn-hc-search-btn]');
        if (searchBtn) {
          self.submitSearch();
          return;
        }

        var topic = event.target.closest('[data-gn-hc-topic]');
        if (topic) {
          var cat = topic.getAttribute('data-gn-hc-topic');
          // Erneuter Klick auf dasselbe Thema hebt den Filter wieder auf.
          self.activeCat = self.activeCat === cat ? null : cat;
          // Kachel-Klick ist ein neuer Einstieg: die alte Suche loeschen,
          // sonst filtern Suchwort UND Thema gemeinsam auf null Treffer.
          if (self.input) self.input.value = '';
          self.syncTopicState();
          self.apply();
          // Nur beim EINschalten runterscrollen. Wer den Filter durch einen
          // zweiten Klick aufhebt, will die Kacheln sehen und nicht an eine
          // andere Stelle geschoben werden.
          if (self.activeCat) {
            self.sendEvent('hc_topic', self.activeCat);
            self.showFeedback();
            self.scrollToResults();
          }
          return;
        }

        var reset = event.target.closest('[data-gn-hc-reset]');
        if (reset) {
          self.activeCat = null;
          if (self.input) {
            self.input.value = '';
          }
          self.syncTopicState();
          self.apply();
          return;
        }

        var fbYes = event.target.closest('[data-gn-hc-feedback-yes]');
        if (fbYes) { self.answerFeedback('up'); return; }
        var fbNo = event.target.closest('[data-gn-hc-feedback-no]');
        if (fbNo) { self.answerFeedback('down'); return; }

        // Sprung zum Chat, waehrend etwas im Suchfeld steht: die getippte Frage
        // wandert mit.
        //
        // Beobachtet: "wie werde ich athlete" oben eingegeben, dann unten
        // auf "Chat starten" — der Chat oeffnete leer, die Frage blieb im
        // Suchfeld stehen. Der Button ist ein reiner Anker (#chat) und wusste
        // vom Suchfeld nichts. Wer den Abschluss-Streifen "Nichts gefunden?"
        // anklickt, hat seine Frage aber gerade getippt; sie noch einmal
        // eintippen zu muessen ist genau der Bruch, den die Seite vermeiden soll.
        //
        // Bewusst am Chat-Aufhaenger erkannt und nicht an der id "chat": die id
        // ist eine Section-Einstellung und kann umbenannt werden.
        var chatJump = event.target.closest('a[href^="#"]');
        if (chatJump) {
          var ziel = document.getElementById((chatJump.getAttribute('href') || '').slice(1));
          var frage = self.input ? self.input.value.trim() : '';
          if (frage && ziel && ziel.querySelector('[data-gorbot-inline]')) {
            event.preventDefault();
            // Dieselbe Kennzahl wie beim Kein-Treffer-Knopf: die Seite hat diese
            // Frage nicht beantwortet, sonst waere der Kunde nicht hier unten.
            self.sendEvent('hc_gorbot', frage);
            self.sendToGorbot(frage);
            return;
          }
        }

        // Sprung zum Kontaktformular auf derselben Seite: der Browser scrollt
        // selbst zum Anker (deshalb KEIN preventDefault), aber unten steht dann
        // nur ein Kasten mit Feldern. Der Fokus im ersten Feld sagt, dass es
        // jetzt weitergeht. Bewusst auf .gn-hc__form eingegrenzt: bei einem
        // Link auf #chat wuerde sonst das Eingabefeld des Widgets den Fokus
        // ziehen.
        //
        // NUR am grossen Bildschirm. Auf dem Handy schiebt die Tastatur genau
        // das Formular aus dem Bild, das der Kunde sehen wollte, und aeltere
        // iOS-Safari ignorieren preventScroll, wodurch der weiche Scroll
        // abbricht. Dort ist der Sprung allein die bessere Antwort.
        var jump = event.target.closest('a[href^="#"]');
        if (jump && self.isWideViewport()) {
          var box = document.getElementById((jump.getAttribute('href') || '').slice(1));
          var field = box && box.querySelector('.gn-hc__form input, .gn-hc__form select, .gn-hc__form textarea');
          if (field && typeof field.focus === 'function') {
            window.setTimeout(function () {
              field.focus({ preventScroll: true });
            }, 400);
          }
        }
      });

      // Mobile: die Bildschirmtastatur belegt die untere Haelfte. Steht das
      // Suchfeld beim Antippen dort, verdeckt sie es und man tippt blind
      // Deshalb beim Fokus das Feld an den OBEREN Rand
      // scrollen — die kleine Pause laesst die Tastatur erst aufklappen,
      // sonst rechnet der Browser mit der alten Viewport-Hoehe.
      var keyboardScrollTimer = null;
      document.addEventListener('focusin', function (event) {
        if (!event.target.matches || !event.target.matches('input[data-gn-hc-search]')) return;
        if (self.isWideViewport()) return;
        if (keyboardScrollTimer) window.clearTimeout(keyboardScrollTimer);
        keyboardScrollTimer = window.setTimeout(function () {
          // Nur scrollen, wenn das Feld NOCH fokussiert ist: hat der Kunde in
          // den 300ms eine Pill getippt, wuerde der Timer ihn sonst vom
          // gerade angesprungenen Treffer wieder nach oben ziehen.
          if (document.activeElement !== event.target) return;
          if (event.target.scrollIntoView) {
            event.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 300);
      });

      // Theme-Editor: Section neu gerendert, Elemente neu einsammeln.
      document.addEventListener('shopify:section:load', function () {
        self.refresh();
        self.watchChat();
      });
    },

    init: function () {
      // Zuerst die Sprachwahl: leitet sie um, ist jede weitere Arbeit auf
      // dieser Seite verloren, die naechste laedt ohnehin frisch.
      if (folgeShopsprache()) return;
      this.bind();
      this.refresh();
      this.watchChat();
      this.watchGorgiasForm();
      this.keepGorgiasFormInView();
      this.showFormSuccess();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      GNHelpCenter.init();
    });
  } else {
    GNHelpCenter.init();
  }
})();
